import React, { Component } from 'react';
import immutable from 'immutable';
import {Panel, Tabs, Tab} from 'react-bootstrap';
import ClosableTab from './ClosableTab'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../redux/modules/tabs';
import NavBar from './NavBar';

import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";

const urlPrefix = __URLPREFIX__;

class TabListMenu extends React.Component {
	render() {
		return <div><ContextMenuTrigger id="TabListContextMenu">{this.props.title}</ContextMenuTrigger></div>
	}
}

class TabMenu extends React.Component {
	render() {
		return <div><ContextMenuTrigger id="TabFormContextMenu">{this.props.title}</ContextMenuTrigger></div>
	}
}

class TabFormContextMenu extends React.Component {
	render() {
		return (
			<ContextMenu id="TabFormContextMenu">
				<MenuItem data={{close:1}} onClick={(e, data) => this.handleSelect(data)}>
					Zavřít
				</MenuItem>
				<MenuItem data={{close:2}} onClick={(e, data) => this.handleSelect(data)}>
					Zavřít ostatní
				</MenuItem>
				<MenuItem data={{close:3}} onClick={(e, data) => this.handleSelect(data)}>
					Zavřít vše
				</MenuItem>
			</ContextMenu>)
	}

	handleSelect(data) {
		this.props.onSelect(data);
	}
}

class TabListContextMenu extends React.Component {
	render() {
		return (
			<ContextMenu id="TabListContextMenu">
				<MenuItem data={{close:3}} onClick={(e, data) => this.handleSelect(data)}>
					Zavřít ostatní
				</MenuItem>
			</ContextMenu>)
	}

	handleSelect(data) {
		this.props.onSelect(data);
	}
}

@connect(
	(state, props) => {
		if (!state.tabs[props.module]) {
			return {
				tabs: [],
				selectedTab: 0
			}
		}
		return {
			tabs: state.tabs[props.module].tabs,
			selectedTab: state.tabs[props.module].selected
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(actions, dispatch)};
	})
export default class TabbablePage extends React.Component {

	static contextTypes= {
		history: React.PropTypes.object,
		router: React.PropTypes.object,
		user: React.PropTypes.object,
		location: React.PropTypes.object
	};

	static defaultProps = {
		newTitle: 'Nový',
		listTitle: 'Seznam',
		disableAdd: false
	};

	constructor(props) {
		super(props);
		this.updateDimensions = this.updateDimensions.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.location != this.props.location) {
			if (nextProps.location.state && nextProps.location.state.openNewTab) {
				this.context.router.replace(nextProps.location.pathname, nextProps.location.query);
				this.handleNewTab()
			}
		}
	}
	componentDidMount() {
		if (this.props.tabs.length == 0) {
			if (this.props.params.id) {
				if (parseInt(this.props.params.id) == 0) {
					this.handleNewTab();
				}
				else {
					const id = this.props.params.id;
					this.props.actions.openTabForm(this.props.module, '...', {id});
					if (!isNaN(id)) {

					}
				}
			}
		}
		else {
			if (this.props.location.state && this.props.location.state.openNewTab) {
				this.handleNewTab();
			}
		}
		if (this.props.selectedTab) {
			const selectedTab = this.props.tabs.filter((tab) => tab.id == this.props.selectedTab)[0];
			if (selectedTab) {
				this.context.router.replace(urlPrefix + '/' + this.props.module + '/' + selectedTab.data);
			}
			//console.log(selectedTab);
		}
		if (typeof this.props.params.id === 'undefined' && this.props.selectedTab !== 0 &&
			this.context.location.query && this.context.location.query.filter) {
			this.props.actions.selectTab(this.props.module, 0);
		}
		window.addEventListener("resize", this.updateDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions);
	}

	handleSelectTab(key) {
		if (key == 'add') {
			this.handleNewTab();
		}
		else {
			//const tab = this.props.tabs.filter(item => item.id == key)[0];
			this.props.actions.selectTab(this.props.module, key);
		}
	}

	handleNewTab(args = null) {
		let data = {id: 0, unsave: true};
		if (args) {
			Object.assign(data, args);
		}
		let title = this.props.newTitle;
		if (args && args.component) {
			data.id = data.component.toLowerCase();
			data.unsave = !!args.unsave;
			title = args.title;
			data = {...data, ...args};
		}
		this.props.actions.openTabForm(this.props.module, title, data);
	}


	handleSelectContextMenu(data) {
		if (data.close == 1) {
			this.props.actions.closeTab(this.props.module, data.id);
		}
		if (data.close == 2) {
			this.props.actions.closeOthersTab(this.props.module, data.id);
		}
		if (data.close == 3) {
			this.props.actions.closeAll(this.props.module);
		}
		if (data.reload) {
			this.refs['tab'+data.id].getWrappedInstance().load();
		}
	}

	handleCloseTab(id) {
		this.props.actions.closeTab(this.props.module, id);
	}

	updateDimensions() {
		this.forceUpdate();
	}

	render() {
		const isPhone = window.matchMedia("only screen and (max-width: 768px)").matches;
		if (isPhone) {
			return this.renderMobile()
		}
		else {
			return this.renderDesktop();
		}
	}

	renderMobile() {
		if (this.props.selectedTab === 0) {
			return <this.props.List module={this.props.module}
							 resource={this.props.resource}
							 actions={this.props.actions}
							 tabActions={this.props.actions}
							 newTab={(args) => this.handleNewTab(args)}
			/>
		}
		else {
			const item = this.props.tabs[0];
			const TabComponent = this.props[item.component ? item.component : 'Form'];
			return (
				<TabComponent
					tabid={item.id}
					resource={this.props.resource}
					ref={'tab' + item.id}
					id={item.data}
					tab={item}
					tabActions={this.props.actions}
					newTab={(args) => this.handleNewTab(args)}
					closeTab={() => this.handleCloseTab(item.id)}
					updateTab={(tab) => this.props.actions.updateTab(this.props.module, item.id, tab)}
				/>);
		}
		return false;
	}

	renderDesktop() {

		const tabs = this.props.tabs.map(item => {
				const title = <ContextMenuTrigger collect={() => {return {id: item.id}}} id="TabFormContextMenu">
					<ClosableTab
					onClose={(key) => this.props.actions.closeTab(this.props.module, key)}
					id={item.id}
					title={item.title}
					unsave={item.unsave}
					/>
				</ContextMenuTrigger>;

				const TabComponent = this.props[item.component ? item.component : 'Form'];

				return <Tab key={item.id} eventKey={item.id} title={title}>
							<TabComponent
									tabid={item.id}
									resource={this.props.resource}
									ref={'tab' + item.id}
								  	id={item.data}
								  	tab={item}
									tabActions={this.props.actions}
									newTab={(args) => this.handleNewTab(args)}
								  	closeTab={() => this.handleCloseTab(item.id)}
								  	updateTab={(tab) => this.props.actions.updateTab(this.props.module, item.id, tab)}
							/>
					   </Tab>;
			}
		);

		return (
			<div className="tdidocument tabbable tab-content-bordered">
				<TabFormContextMenu onSelect={(data) => this.handleSelectContextMenu(data)} />
				<TabListContextMenu onSelect={(data) => this.handleSelectContextMenu(data)} />
				<Tabs id="tabs" onSelect={(key) => this.handleSelectTab(key)}
					activeKey={this.props.selectedTab}
					animation={false}>
					<Tab eventKey={0} title={<TabListMenu title={this.props.listTitle} />}>
						<this.props.List module={this.props.module}
										 resource={this.props.resource}
										 actions={this.props.actions}
										 tabActions={this.props.actions}
										 newTab={(args) => this.handleNewTab(args)}
						/>
					</Tab>
					{tabs}
					{!this.props.disableAdd &&
					(!this.props.resource || this.context.user.isAllowed(this.props.resource, 'insert')) &&
					<Tab eventKey="add"
						 title={<div><span><span className="icon-plus3" style={{fontSize: 12}} /> <span className="show-tablet">přidat</span></span></div>}/>
					}
				</Tabs>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TabbablePage.js